import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "services/common"

interface ConfirmRequestSubmittedResponse extends AxiosResponse {
  data: {
    data: boolean
    message: string
    apiStatus: ApiStatus
  }
}

export interface ConfirmRequestSubmittedRequest
  extends Partial<AxiosRequestConfig> {
  bookingNumber: string
}

export function confirmRequestSubmittedApi(
  { bookingNumber, ...config }: ConfirmRequestSubmittedRequest,
  axiosInstance: AxiosInstance,
): Promise<ConfirmRequestSubmittedResponse> {
  return axiosInstance({
    method: "post",
    url: `/admin/booking/confirm-booking?bookingNumber=${bookingNumber}`,
    ...config,
  }) as Promise<ConfirmRequestSubmittedResponse>
}
